import React from 'react';
import { Clock, Calendar } from 'lucide-react';
import { operatingHours } from '../data/mock';

const HoursSection = () => {
  const today = new Date().getDay();
  const dayMapping = [6, 0, 1, 2, 3, 4, 5]; // Adjust for operatingHours array (Segunda = 0)

  return (
    <section id="horarios" className="section-padding bg-stone-50 relative overflow-hidden" aria-labelledby="hours-heading">
      {/* Background decoration */}
      <div className="absolute top-0 right-0 w-96 h-96 bg-amber-100 rounded-full blur-3xl opacity-50" />
      <div className="absolute bottom-0 left-0 w-72 h-72 bg-amber-200 rounded-full blur-3xl opacity-50" />

      <div className="container mx-auto px-6 relative z-10">
        <div className="max-w-4xl mx-auto">
          {/* Section Header */}
          <div className="text-center mb-16">
            <span className="text-amber-700 font-medium tracking-widest uppercase text-sm">
              Atendimento
            </span>
            <h2 id="hours-heading" className="font-serif text-4xl md:text-5xl lg:text-6xl font-bold text-neutral-900 mt-4 mb-6">
              Horário de Funcionamento
            </h2>
            <div className="w-24 h-1 bg-gradient-to-r from-amber-700 to-amber-500 mx-auto mb-6" />
            <p className="text-neutral-600 text-lg">
              Aberto todos os dias das 18h às 23h
            </p>
          </div>

          {/* Hours Card */}
          <div className="bg-white rounded-3xl shadow-xl overflow-hidden">
            {/* Header */}
            <div className="bg-neutral-900 p-6 flex items-center gap-4">
              <div className="w-14 h-14 bg-amber-700 rounded-xl flex items-center justify-center">
                <Clock className="text-white" size={28} aria-hidden="true" />
              </div>
              <div>
                <h3 className="font-semibold text-white text-xl">Horários da Semana</h3>
                <p className="text-white/60">18:00 às 23:00 - Todos os dias</p>
              </div>
            </div>

            {/* Hours List */}
            <dl className="divide-y divide-neutral-100">
              {operatingHours.map((schedule, index) => {
                const isToday = dayMapping[today] === index;
                const isClosed = schedule.closed;
                
                return (
                  <div
                    key={index}
                    className={`flex items-center justify-between p-5 transition-colors ${
                      isToday ? 'bg-amber-50' : 'hover:bg-neutral-50'
                    }`}
                  >
                    <dt className="flex items-center gap-4">
                      <div className={`w-10 h-10 rounded-lg flex items-center justify-center ${
                        isToday ? 'bg-amber-600' : 'bg-neutral-100'
                      }`}>
                        <Calendar className={isToday ? 'text-white' : 'text-neutral-400'} size={18} aria-hidden="true" />
                      </div>
                      <span className={`font-medium ${
                        isToday ? 'text-amber-800' : 'text-neutral-700'
                      }`}>
                        {schedule.day}
                        {isToday && (
                          <span className="ml-2 text-xs bg-amber-600 text-white px-2 py-0.5 rounded-full">
                            Hoje
                          </span>
                        )}
                      </span>
                    </dt>
                    <dd className={`font-semibold ${
                      isClosed ? 'text-red-500' : isToday ? 'text-amber-800' : 'text-neutral-900'
                    }`}>
                      {schedule.hours}
                    </dd>
                  </div>
                );
              })}
            </dl>

            {/* Footer note */}
            <div className="bg-neutral-50 p-4 text-center">
              <p className="text-neutral-500 text-sm">
                * Horários sujeitos a alterações em feriados
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default HoursSection;
